import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { PaymentMethodDateQuantityTypesKeys, paymentMethodQuantityTypesInversed } from '@teinor/erp/types/company/config/paymentMethod/paymentMethodDate'
import { PayMCopyDateModeAddExtended } from '../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod/types'
import { TwinDictionary } from '../dictionary'

export const getQuantityToPayModalPayM = (total: number, quantity: number, type_quantity: PaymentMethodDateQuantityTypesKeys) => {
    let result = 0
    if (type_quantity === paymentMethodQuantityTypesInversed['percentage']) {
        result = roundNumberAndDecimals(total * (quantity / 100), totalCalculateParams )
    } else if (type_quantity === paymentMethodQuantityTypesInversed['quantity']) {
        result = quantity
    }
    return result
}

export const recalculateQuantitiesModalPayM = (total: number, paymentMethodDates: PayMCopyDateModeAddExtended[]) => {
    let myTotalAccumulated = 0
    if (paymentMethodDates) {
        for (let i = 0; i < paymentMethodDates?.length - 1; i++) {
            const element = paymentMethodDates[i]
            if (element?.quantity && String(element.quantity) === ''){
                element.quantity = 0
            }
            const isLast = i === paymentMethodDates.length - 2
            if (isLast) {
                const result = roundNumberAndDecimals(parseFloat(String(total)) - myTotalAccumulated, totalCalculateParams)
                element.quantity = result > 0 ? result : 0
                break
            }
            const presetMyTotalAccumulated = roundNumberAndDecimals(myTotalAccumulated + parseFloat(String(element.quantity)), totalCalculateParams)
            if (presetMyTotalAccumulated > total) {
                element.quantity = roundNumberAndDecimals(total - myTotalAccumulated, totalCalculateParams)
                myTotalAccumulated = total
            } else {
                myTotalAccumulated = presetMyTotalAccumulated
            }
        }
    }
}

export const recalculateAllQuantitiesModalPayM = (total: number, paymentMethodDates: PayMCopyDateModeAddExtended[], basePaymentMethodDates: TwinDictionary[]) => {
    let myTotalAccumulated = 0
    for (let i = 0; i < paymentMethodDates?.length; i++) {
        const baseElement = basePaymentMethodDates?.[i]
        const actualElement = paymentMethodDates[i]
        if (actualElement.subId === 'addButton') {
            break
        }
        let isLast = false
        if (i === basePaymentMethodDates.length - 1 || i === paymentMethodDates.length - 2) {
            isLast = true
        }
        let myQuantity = 0
        if (isLast) {
            myQuantity = roundNumberAndDecimals(total - myTotalAccumulated, totalCalculateParams)
        } else {
            myQuantity = roundNumberAndDecimals(getQuantityToPayModalPayM(parseFloat(String(total)), baseElement?.quantity || 0, baseElement?.type_quantity || 0), totalCalculateParams)
        }
        myTotalAccumulated = roundNumberAndDecimals(myTotalAccumulated + myQuantity, totalCalculateParams)
        actualElement.quantity = myQuantity
    }
}

export const parsePaymentMethodDates = (paymentMethodDates: PayMCopyDateModeAddExtended[], total: number, isReadOnly: boolean) => {
    let errorTotalNotMatch = false
    const copyPaymentDates = JSON.parse(JSON.stringify(paymentMethodDates))
    let myTotalAccumulated = 0
    for (const element of copyPaymentDates) {
        element.date = new Date(element.date)
        element.quantity = parseFloat(String(element.quantity))
        element.payment_data = element.PayTCopy.new_extra_payment_data?.id || ''
        myTotalAccumulated = roundNumberAndDecimals(myTotalAccumulated + element.quantity, totalCalculateParams)
    }
    if (myTotalAccumulated !== total) {
        errorTotalNotMatch = true
    }
    if (!isReadOnly) {
        copyPaymentDates.push({ subId: 'addButton' })
    }
    return { errorTotalNotMatch, paymentMethodDates: copyPaymentDates }
}